"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBaseContentClient = void 0;
var axios_1 = __importDefault(require("axios"));
/**
 * Create base network client to make requests to the content delivery service
 * @param config
 * @hidden
 */
function createBaseContentClient(config, defaultHost) {
    var client = axios_1.default.create({
        adapter: config.adaptor,
        timeout: config.timeout || 0,
    });
    if (config.stagingEnvironment) {
        client.defaults.baseURL = "https://".concat(config.stagingEnvironment);
    }
    else {
        client.defaults.baseURL = config.baseUrl || defaultHost;
    }
    return client;
}
exports.createBaseContentClient = createBaseContentClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlQmFzZUNvbnRlbnRDbGllbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2NsaWVudC9jcmVhdGVCYXNlQ29udGVudENsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFDQSxnREFBNkM7QUFFN0M7Ozs7R0FJRztBQUNILFNBQWdCLHVCQUF1QixDQUNyQyxNQUFpQyxFQUNqQyxXQUFtQjtJQUVuQixJQUFNLE1BQU0sR0FBRyxlQUFLLENBQUMsTUFBTSxDQUFDO1FBQzFCLE9BQU8sRUFBRSxNQUFNLENBQUMsT0FBTztRQUN2QixPQUFPLEVBQUUsTUFBTSxDQUFDLE9BQU8sSUFBSSxDQUFDO0tBQzdCLENBQUMsQ0FBQztJQUVILElBQUksTUFBTSxDQUFDLGtCQUFrQixFQUFFO1FBQzdCLE1BQU0sQ0FBQyxRQUFRLENBQUMsT0FBTyxHQUFHLGtCQUFXLE1BQU0sQ0FBQyxrQkFBa0IsQ0FBRSxDQUFDO0tBQ2xFO1NBQU07UUFDTCxNQUFNLENBQUMsUUFBUSxDQUFDLE9BQU8sR0FBRyxNQUFNLENBQUMsT0FBTyxJQUFJLFdBQVcsQ0FBQztLQUN6RDtJQUNELE9BQU8sTUFBTSxDQUFDO0FBQ2hCLENBQUM7QUFmRCwwREFlQyJ9